import API from 'services/api';

export const getBillingInformation = (customerId: string | number | undefined) => {
  return API.get(`/api/customers/${customerId}`).then(res => res?.data);
};
